export default "__VITE_ASSET__BOU_w4b2__"